import React, {useCallback, useMemo} from 'react';
import {Concept} from 'types';
import {useLocalization} from 'localization';
import type {Agent} from 'api';
import {ActionButton, useSnacks} from 'components';
import {formatNameVariantValue} from 'schema/preview/functions';
import {usePostNorafUpdateIgnoreItem} from '../../agents/hooks/usePostNorafUpdateIgnoreItem';

type Props = {
  agent?: Agent;
};
export const AgentIgnoreButton: React.FC<Props> = ({agent}) => {
  const {t} = useLocalization();
  const agentChangeIgnorer = usePostNorafUpdateIgnoreItem();
  const {successSnack} = useSnacks();

  const canIgnore = useMemo(() => {
    return (
      agent?.nationalId &&
      agent?.id &&
      agent?.nameVariants?.[0] &&
      agent?.agentType === Concept.person
    );
  }, [agent?.nationalId, agent?.id, agent?.nameVariants, agent?.agentType]);

  const onIgnore = useCallback(() => {
    if (agent?.nationalId && agent?.id && agent?.nameVariants?.[0]) {
      agentChangeIgnorer(
        agent?.nationalId,
        agent?.id,
        formatNameVariantValue(
          agent?.nameVariants?.[0],
          agent?.agentType,
          'excludeId',
        ),
      ).then(() => {
        successSnack(t('page.agents.noraf.changes.ignore.success', {count: 1}));
      });
    }
  }, [
    agent?.nationalId,
    agent?.id,
    agent?.nameVariants,
    agentChangeIgnorer,
    agent?.agentType,
    successSnack,
    t,
  ]);

  if (!canIgnore) {
    return null;
  }

  return (
    <ActionButton
      onClick={onIgnore}
      background={'transparent'}
      title={'Ignorer endringer'}
    />
  );
};
